import Dialog from './Dialog.js';

class UserSignInDialog extends Dialog {
    static create({id, env}) {
        return new UserSignInDialog({id, decorator: env.getDecorator()});
    }

    static getCreateAccountLink() {
        return $('#user-sign-in-dialog').find('.create-account-link');
    }

    constructor({id, decorator}) {
        super({id, autoInitEvents: false});

        this.activeSectionCls = 'user-sign-in-section-active';

        this.form = this.find('form');
        this.accountSection = this.find('.user-sign-in-account-section');
        this.accountFieldsWrap = decorator.sectionError(this.accountSection.find('.user-sign-in-account-section-fields-wrap'));
        this.guestSection = this.find('.user-sign-in-guest-section');
        this.signInButton = decorator.spinnerButton(this.find('.sign-in-button'));
        this.accountRadio = this.accountSection.find('input[type=radio]');
        this.guestRadio = this.guestSection.find('input[type=radio]');
        this.emailField = decorator.errorAndEnterKeyPress(this.find('.email-input'));
        this.passwordField = decorator.errorAndEnterKeyPress(this.find('.password-input'));
        this.cardNumberField = decorator.errorAndEnterKeyPress(this.find('.card-number-input'));
        this.createAccountLink = decorator.preventDefaultClick(this.find('.create-account-link'));
        this.resetPasswordLink = decorator.preventDefaultClick(this.find('.reset-password-link'));

        this.initEvents();
    }

    initEvents() {
        super.initEvents();

        this.form.on('submit', e => {
            this.maybeTrigger('submitGesture');
            e.preventDefault();
        });

        this.guestSection.click(() => this.setGuestSectionActive(true));
        this.accountSection.click(() => this.setGuestSectionActive(false));
        this.emailField.on('focus', () => this.setGuestSectionActive(false));
        this.passwordField.on('focus', () => this.setGuestSectionActive(false));
        this.cardNumberField.on('focus', () => this.setGuestSectionActive(false));
        this.createAccountLink.click(() => this.maybeTrigger('createAccountLink:click'));
        this.resetPasswordLink.click(() => this.maybeTrigger('resetPasswordLink:click'));
    }

    addAccountSectionError(message) {
        this.accountFieldsWrap.addError(message);
    }

    addCardNumberRequiredError() {
        this.cardNumberField.addError('Please provide a valid library card number to sign in.');
        this.focusCardNumberField();
    }

    addEmailRequiredError() {
        this.emailField.addError('Please provide a valid email address to sign in.');
        this.focusEmailField();
    }

    addPasswordRequiredError() {
        this.passwordField.addError('Please provide a valid password to sign in.');
        this.passwordField.focus();
    }

    clearPassword() {
        this.passwordField.val('');
    }

    focusCardNumberField() {
        this.cardNumberField.focus();
    }

    focusEmailField() {
        this.emailField.focus();
    }

    getEmail() {
        return this.emailField.val();
    }

    getForm() {
        return this.form[0];
    }

    getPassword() {
        return this.passwordField.val();
    }

    getState() {
        var email = this.getEmail(),
            password = this.getPassword(),
            cardNumber = this.cardNumberField.val();

        return {email, password, cardNumber};
    }

    guestSectionActive() {
        return this.guestSection.hasClass(this.activeSectionCls);
    }

    setEmail(email) {
        this.emailField.val(email);
    }

    setGuestSectionActive(active) {
        this.guestSection.toggleClass(this.activeSectionCls, active);
        this.accountSection.toggleClass(this.activeSectionCls, !active);

        this.guestRadio.prop('checked', active);
        this.accountRadio.prop('checked', !active);
    }

    setSubmitting(submitting) {
        this.setEventsEnabled(!submitting);
        this.signInButton.toggleSpinner(submitting);
    }
}

export default UserSignInDialog;